import { Reveal, Overline } from "./Reveal";
import { Check, ArrowUpRight } from "lucide-react";

const tiers = [
  {
    name: "Consulting Engagements",
    tagline: "Advisory & architecture",
    features: ["Technology strategy & roadmapping", "Solution architecture reviews", "Feasibility & PoC development", "Security & compliance assessment"],
    featured: false,
  },
  {
    name: "Custom Solutions",
    tagline: "End-to-end engineering",
    features: ["Dedicated engineering pods", "Full product design & build", "Integration & automation delivery", "AI & cloud-native implementation", "Priority roadmap partnership"],
    featured: true,
  },
  {
    name: "Managed Services",
    tagline: "Operate & evolve",
    features: ["24/7 monitoring & support", "Continuous optimization", "Proactive maintenance & SLAs", "Ongoing feature evolution"],
    featured: false,
  },
];

export const Pricing = () => {
  const go = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="pricing" className="relative z-10 border-t border-white/10 bg-ink-900/40 py-24 md:py-32" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="text-center">
          <Reveal className="flex justify-center"><Overline>Engagement Models</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mx-auto mt-6 max-w-2xl font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl md:text-5xl">
              Flexible engagements, tailored to your enterprise.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mx-auto mt-5 max-w-xl text-base text-zinc-400">
              Every engagement is scoped to your goals. Pricing is custom — reach out for a
              tailored proposal.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {tiers.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 0.08}
              className={`relative flex flex-col rounded-2xl p-8 ${
                t.featured
                  ? "tracing-border bg-ink-900 lg:-mt-4 lg:mb-4"
                  : "border border-white/10 bg-ink-950"
              }`}
              data-testid={`pricing-tier-${i}`}
            >
              {t.featured && (
                <span className="absolute -top-3 left-8 rounded-full bg-brand px-3 py-1 text-xs font-semibold text-ink-950">
                  Most Popular
                </span>
              )}
              <h3 className="font-display text-2xl font-bold tracking-tight text-white">{t.name}</h3>
              <p className="mt-2 text-sm text-zinc-500">{t.tagline}</p>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-display text-4xl font-black text-white">Custom</span>
                <span className="text-sm text-zinc-500">pricing</span>
              </div>
              <ul className="mt-8 flex flex-1 flex-col gap-3">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-zinc-300">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={go}
                data-testid={`pricing-cta-${i}`}
                className={`group mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold transition-transform duration-300 hover:scale-[1.02] ${
                  t.featured
                    ? "bg-brand text-ink-950 glow-cyan"
                    : "border border-white/15 bg-white/5 text-white hover:border-brand/50"
                }`}
              >
                Request Consultation
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
